import { QueryHookOptions, useQuery } from '@apollo/client'
import {
  findSchoolListByPlatform,
  findSchoolListByPlatformVariables,
} from '__generatedTypes__/findSchoolListByPlatform'
import { FIND_SCHOOL_LIST_BY_PLATFORM } from 'queries/faculty'

export function useFindSchoolsByPlatformQuery(
  options?: QueryHookOptions<findSchoolListByPlatform, findSchoolListByPlatformVariables>
) {
  return useQuery<findSchoolListByPlatform, findSchoolListByPlatformVariables>(FIND_SCHOOL_LIST_BY_PLATFORM, options)
}
